// @flow

export const WS_GET_LANDING_REQUEST = 'WS_GET_LANDING_REQUEST';
export const WS_GET_LANDING_SUCCESS = 'WS_GET_LANDING_SUCCESS';
export const WS_GET_LANDING_ERROR = 'WS_GET_LANDING_ERROR';
export const SAVE_LANDING_USER_DATA = 'SAVE_LANDING_USER_DATA';
